<template>
  <div>
    <el-form class="el-form-m20" :inline="true" size="small">
      <el-form-item class="search-bar">
        <el-input :class="{'w-30vw':normal,'w-100per':!normal}"
                  placeholder="请输入试题或考试工种关键字" v-model="searchValue">
          <el-button class="btn-search" @click="search" icon="el-icon-search" slot="append"></el-button>
        </el-input>
      </el-form-item>
      <el-form-item v-if="normal">
        <el-button-group>
          <el-button v-if="perm.indexOf('topic:insert') > -1" type="primary" icon="el-icon-document-add"
                     @click="addTopic">添加试题
          </el-button>
          <!--          权限要修改-->
          <el-button v-if="perm.indexOf('topic:downloadTpl') > -1" type="primary" icon="el-icon-download"
                     @click="downloadTpl">试题模板下载
          </el-button>
          <el-button v-if="perm.indexOf('topic:sync') > -1" type="warning" icon="el-icon-refresh"
                     @click="syncTopic">同步试题
          </el-button>
          <el-button v-if="perm.indexOf('topic:delete') > -1" type="danger" icon="el-icon-delete"
                     @click="deleteSlt">批量删除
          </el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item v-if="normal">
        <el-button-group>
          <!--
          上传只接受excel
          -->
          <el-upload
              :show-file-list="false"
              name="importTopicsExcel"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              :http-request="uploadExcel"
              :before-upload="preUpload"
              :action="apiUrl + 'importTopics'">
            <el-button slot="trigger" v-if="perm.indexOf('topic:import') > -1" type="primary" icon="el-icon-upload2">
              批量导入试题
            </el-button>
          </el-upload>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table
        ref="tqTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="topicId"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column prop="topicId" label="编号" width="100" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="topic" label="题目" width="360" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="suject" label="考试工种">
      </el-table-column>
      <el-table-column prop="questionType" label="题型" width="50" :formatter="formatQuestionType">
      </el-table-column>
      <el-table-column prop="answer" label="答案" width="300" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="correctAnswer" label="正确答案" width="100">
      </el-table-column>
      <el-table-column v-if="normal" label="操作">
        <template slot-scope="scope">
          <el-link v-if="perm.indexOf('topic:update') > -1"
                   type="primary"
                   icon="el-icon-edit"
                   @click="modifyRow(scope.$index, scope.row)">修改答案
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :layout="normal ? 'sizes, prev, pager, next' : 'prev, pager, next'"
        :page-size="size"
        :total="total"
        :current-page.sync="index"
        @size-change="sizeChange"
        @current-change="currentChange">
    </el-pagination>
    <el-dialog v-if="normal && (perm.indexOf('topic:update') > -1 || perm.indexOf('topic:insert'))" @close="cancelForm"
               @open="pullSuject" :title="title"
               width="55%" top="10vh"
               :visible.sync="dialogFormVisible"
               :lockScroll="false">
      <!--      private String answer;
            private String correctAnswer;-->
      <div slot="title">
        <span class="el-dialog__title">{{ title }}</span>
        <span v-if="title.indexOf('添加') > -1" class="dialog-subtitle">
          考试工种、题目、题型添加后不能修改，确认前请检查
        </span>
      </div>
      <el-form ref="testQuestionForm" :model="form" label-position="right" label-width="80px">
        <el-form-item prop="suject" label="考试工种" :rules="rules" :required="true">
          <el-autocomplete v-model="form.suject" :disabled="title.indexOf('修改') > -1" :maxlength="255"
                           :fetch-suggestions="filterSuject" class="w-full"
                           placeholder="请输入考试工种"></el-autocomplete>
        </el-form-item>
        <el-form-item prop="topic" label="题目" :rules="rules" :required="true">
          <el-input type="textarea" :rows="4" :readonly="title.indexOf('修改') > -1" :maxlength="400"
                    :show-word-limit="true" v-model="form.topic" placeholder="请输入题目" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="questionType" label="题型" :required="true">
          <el-radio-group v-model="form.questionType" :disabled="title.indexOf('修改') > -1">
            <el-radio-button label="radio">单选</el-radio-button>
            <el-radio-button label="check">多选</el-radio-button>
            <el-radio-button label="rightAndWrong">对错</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-row v-if="form.questionType!=='rightAndWrong'">
          <el-row v-for="(item,key,i) in form.answer" :key="i">
            <el-col :span="20">
              <el-form-item :prop="'answer.answer'+(i+1)" :label="answerLabel[i]" :rules="rules" :required="true">
                <el-input v-model="form.answer[key]" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" class="content-center">
              <el-checkbox :label="answerLabel[i]" v-model="form.correctAnswer">正确答案
              </el-checkbox>
            </el-col>
          </el-row>
        </el-row>

        <el-form-item v-else prop="correctAnswer" label="正确答案" :required="true">
          <el-radio-group v-model="form.correctAnswer[0]" size="medium">
            <el-radio-button label="1">对</el-radio-button>
            <el-radio-button label="0">错</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button icon="el-icon-plus" @click="addAnswer">增加答案</el-button>
        <el-button icon="el-icon-minus" @click="removeAnswer">减少答案</el-button>
        <el-button type="primary" @click="confirmForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import helper from "../common/CZHelper";
import CZHelper from "../common/CZHelper";

export default {
  name: "TestQuestions",
  props: {
    normal: {
      type: Boolean,
      default: true
    }
  },
  beforeRouteEnter(to, from, next) {
    //获取不了this，会携带请求头
    next(self => {
      self.getList();
    });
  },
  methods: {
    syncTopic() {
      this.$confirm('数据同步占用资源较大，建议深夜操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        this.$axios.get(this.apiUrl + 'syncData').then(({data}) => {
          if (data.code == 200)
            this.$message.success('数据同步成功');
          else
            this.$message.error('数据同步失败');
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    addTopic() {
      this.dialogFormVisible = true;
      this.title = '添加题目';
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    removeAnswer() {
      if (this.answerCount > 4) {
        this.$delete(this.form.answer, ('answer' + this.answerCount--));
      } else
        this.$message.warning('备选答案至少剩余4个');
    },
    addAnswer() {
      if (this.answerCount < 9)
        this.$set(this.form.answer, 'answer' + ++this.answerCount, null);
      else
        this.$message.warning('备选答案最多添加9个');
    },
    pullSuject() {
      this.$axios.get(this.apiUrl + 'suject/list').then(({data}) => {
        this.sujectList = data;
        // 获取考试工种在open事件，所以重置表单reset
      });
    },
    confirmAnswer() {
      let filter = this.form.correctAnswer.slice(1, this.form.correctAnswer.length).filter(item => item !== '0');
      if (this.form.questionType === 'radio' && filter.length >= 2) {
        this.$message.error('单选题答案不应该有多个');
        return false;
      } else if (this.form.questionType === 'check' && filter.length < 2) {
        this.$message.error('多选题答案至少2个以上');
        return false;
      } else if ((this.form.questionType === 'radio' || this.form.questionType === 'check') && filter.length === 0) {
        this.$message.error('请选择正确答案');
        return false;
      }
      return true;
    },
    filterSuject(queryString, cb) {
      let filter = this.sujectList.filter(item => item.indexOf(queryString) > -1);
      let result = (filter.length ? filter : this.sujectList).map(item => {
        return {"value": item}
      });
      // 调用 callback 返回建议列表的数据
      cb(result);
    },
    cancelForm() {
      this.dialogFormVisible = false;
    },
    confirmForm() {
      this.$refs['testQuestionForm'].validate((valid) => {
        if (valid && this.confirmAnswer()) {
          let tmp = this.getFormStructure();
          if (this.form.questionType === 'rightAndWrong') {
            tmp.correctAnswer = this.form.correctAnswer[0];
            tmp.answer = "正确" + this.separator + "错误";
          } else {
            // *#作为分隔符，这样不容易与题目内容相撞
            tmp.correctAnswer = this.form.correctAnswer.slice(1, this.form.correctAnswer.length).join(this.separator);
            tmp.answer = Object.values(this.form.answer).filter(item => item != null && item.trim() != '').join(this.separator);
          }
          tmp.suject = this.form.suject;
          tmp.createTime = this.form.createTime;
          tmp.questionType = this.form.questionType;
          tmp.topic = this.form.topic;

          this.$axios.post(this.apiUrl + 'add', {topic: JSON.stringify(tmp)}).then(({data}) => {
            if (data.code === 200) {
              this.getList();
              this.$message.success(this.title + "成功");
              if (this.title.indexOf('修改') > -1)
                this.dialogFormVisible = false;
              else
                this.resetForm()
            } else {
              this.$message.error(this.title + "失败");
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      let tmp = this.form.questionType;
      this.form = this.getFormStructure();
      this.form.questionType = tmp;
      this.$refs['testQuestionForm'].resetFields();
    },
    getFormStructure() {
      return {
        suject: null,
        topic: null,
        answer: {
          answer1: null,
          answer2: null,
          answer3: null,
          answer4: null
        },
        // 下标是0的为对错答案，其余下标是选择题答案
        correctAnswer: ['0'],
        questionType: 'radio',
        createTime: 0
      }
    },
    getList() {
      let params = {
        index: this.index,
        size: this.size,
        topic: JSON.stringify(this.topic)
      };
      helper.getList(this.apiUrl + 'list', params, this);
    },
    search() {
      this.index = 1;
      this.topic.suject = this.topic.topic = this.searchValue
      this.getList();
    },
    handleSelectionChange(val) {
      // 非页面展示（对话框模式），触发事件
      if (!this.normal) this.$emit("rowSelected", val);
      this.selectedRows = val;
    },
    deleteSlt() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        if (this.selectedRows.length <= 0) return;
        let params = {ids: JSON.stringify(this.selectedRows.map(item => "'" + item.topicId + "'"))};
        this.$axios.post(this.apiUrl + 'remove', params).then(({data}) => {
          if (data.code === 200) {
            this.clearSelection();
            this.$message.success("题目删除成功");
            this.getList();
          } else {
            this.$message.error("题目删除失败");
          }
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    clearSelection() {
      this.selectedRows.length = 0;
      this.$refs['tqTable'].clearSelection();
    },
    formatQuestionType(row, column, cellValue, index) {
      return this.qtMap[cellValue];
    },
    sizeChange(val) {
      this.size = val;
      this.getList();
    },
    currentChange(val) {
      this.index = val;
      this.getList();
    },
    modifyRow(rowIndex, row) {
      this.title = '修改答案';
      this.dialogFormVisible = true;
      this.form.suject = row.suject;
      this.form.createTime = row.createTime;
      this.form.topic = row.topic;
      this.form.questionType = row.questionType;
      this.form.answer = this.convertAnswer(row.answer);
      this.form.correctAnswer = row.correctAnswer.split(this.separator);
      if (row.questionType !== 'rightAndWrong')
        this.form.correctAnswer.unshift('0');
    },
    convertAnswer(val) {
      let tmp = val.split(this.separator);
      let key = "answer";
      let answerObj = {};
      tmp.forEach((item, i) => {
        answerObj[key + (i + 1)] = item;
      });
      return answerObj;
    },
    preUpload(file) {
      // 10M限制
      let fileSize = file.size / 1000 / 1000;
      if (fileSize > 10) {
        this.$message.error('题库导入不能超过10M');
        return false;
      }
      return true;
    },
    uploadExcel(params) {
      const formData = new FormData();
      formData.append(params.filename, params.file);
      this.$axios({
        method: 'post',
        url: params.action,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(({data}) => {
        let fileName = params.file.name;
        if (data.code === 200) {
          this.$message.success(fileName + ' 导入成功');
          this.getList();
        } else
          this.$message.warning(fileName + ' 导入失败');
      });
    },
    downloadTpl() {
      this.$axios({
        url: this.apiUrl + "downloadTpl",
        method: 'post',
        responseType: 'arraybuffer'
      }).then((resp) => {
        CZHelper.ajaxDownload(resp, "批量导入试题模板.xlsx");
      });
    }
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL + "ma/topic/",
      perm: localStorage.getItem('perm').split(","),
      dialogFormVisible: false,
      qtMap: {"radio": "单选", "check": "多选", "rightAndWrong": "对错"},
      title: "添加题目",
      list: [],
      answerLabel: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
      searchValue: '',
      total: 0,
      size: this.normal ? 10 : 6,
      answerCount: 4,
      index: 1,
      selectedRows: [],
      sujectList: [],
      separator: '*#',
      // element ui 上传不用axios，所以拦截器无用，缺少token不能访问api，手动追加
      // token: localStorage.getItem('token'),
      topic: {
        suject: null,
        topic: null
      },
      rules: [
        {required: true, message: '请输入内容'}
      ],
      form: this.getFormStructure()
    }
  }
}
</script>

<style scoped>
@import "../css/common.css";

.el-form-m20 {
  margin: 0 10px;
  /*text-align: right;*/
}

.content-center {
  text-align: center;
  line-height: 40px;
}

.dialog-subtitle {
  color: darkred;
  font-weight: lighter;
  font-size: 1em;
  margin-left: 20px;
}

.remove {
  display: block;
  font-size: 1.2em;
  cursor: pointer;
  color: darkred;
}

</style>